import { parseAsArrayOf, parseAsBoolean, parseAsInteger, parseAsString, parseAsStringEnum, useQueryStates } from "nuqs";

import { CollectionsBankTransactionStatus } from "@fitness-app/data-models/entities/CollectionsBankTransaction";
import { CollectionsCaseStatus } from "@fitness-app/data-models/entities/CollectionsCase";

export const COLLECTIONS_PAGE_SIZES = [10, 25, 50, 100];

/**
 * The Należności tab keeps its filters and pages in the URL, so coming back from a
 * case card lands on the same page of the same list. Keys are short and prefixed:
 * the tab lives next to other Produkty tabs on `/products?tab=collections`.
 */
export const useCollectionsUrlState = () =>
  useQueryStates(
    {
      query: parseAsString.withDefault(""),
      statuses: parseAsArrayOf(parseAsStringEnum(Object.values(CollectionsCaseStatus))).withDefault([]),
      showClosed: parseAsBoolean.withDefault(false),
      showRetrying: parseAsBoolean.withDefault(false),
      page: parseAsInteger.withDefault(1),
      pageSize: parseAsInteger.withDefault(25),
      queuePage: parseAsInteger.withDefault(1),
      queuePageSize: parseAsInteger.withDefault(10),
      bankStatus: parseAsStringEnum(Object.values(CollectionsBankTransactionStatus)).withDefault(
        CollectionsBankTransactionStatus.Unmatched,
      ),
      bankPage: parseAsInteger.withDefault(1),
      bankPageSize: parseAsInteger.withDefault(20),
    },
    {
      history: "replace",
      clearOnDefault: true,
      urlKeys: {
        query: "cq",
        statuses: "cs",
        showClosed: "cz",
        showRetrying: "cr",
        page: "cp",
        pageSize: "cn",
        queuePage: "qp",
        queuePageSize: "qn",
        bankStatus: "bs",
        bankPage: "bp",
        bankPageSize: "bn",
      },
    },
  );

/** antd pagination wired to a page / page-size pair; a new page size starts from page 1. */
export const urlPagination = (
  page: number,
  pageSize: number,
  set: (next: { page: number; pageSize: number }) => void,
) => ({
  current: page,
  pageSize,
  showSizeChanger: true,
  pageSizeOptions: COLLECTIONS_PAGE_SIZES,
  hideOnSinglePage: true,
  onChange: (nextPage: number, nextSize: number) =>
    set({ page: nextSize === pageSize ? nextPage : 1, pageSize: nextSize }),
});
